// systolic function

  // Insert shrink icon
    // const featuresSnippet = document.getElementById('featuresSnippet');
    // const mobileArrowHTML = `
    // <div class="mobile-arrow">
    //   <div class="arroritem">
    //     <svg t="1742887918255" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
    //       p-id="967" width="200" height="200">
    //       <path
    //         d="M844.016941 271.058824h-70.535529a15.058824 15.058824 0 0 0-12.16753 6.204235L493.929412 645.842824 226.484706 277.263059a15.058824 15.058824 0 0 0-12.047059-6.204235H143.721412a7.529412 7.529412 0 0 0-6.083765 11.926588l331.896471 457.547294c12.047059 16.564706 36.683294 16.564706 48.609882 0l331.896471-457.547294a7.469176 7.469176 0 0 0-6.02353-11.926588z"
    //         fill="#333333" p-id="968"></path>
    //     </svg>
    //   </div>
    // </div>
    // `;
    
    // featuresSnippet.insertAdjacentHTML('beforeend', mobileArrowHTML);
  // Insert shrink icon

  // ul contraction function


  // document.addEventListener("DOMContentLoaded", function () {
  //   const ul = document.querySelector('#featuresSnippet ul');
  //   const arrow = document.querySelector('.arroritem');
  //   const mobileArrow = document.querySelector('.mobile-arrow');
  //   const liElements = ul.querySelectorAll('li');
  //   let twoLiHeight = 0;
  //   setTimeout(() => {
  //     if (liElements.length > 1) {
  //       twoLiHeight = liElements[0].offsetHeight + liElements[1].offsetHeight;
  //       // twoLiHeight = liElements[0].offsetHeight;
  //     }
  //     ul.style.height = `${twoLiHeight}px`;
  //   }, 300);
    
  //   function toggleList() {
  //     if (!ul.classList.contains('expanded')) {
  //       ul.style.height = `${ul.scrollHeight}px`;
  //       ul.classList.add('expanded');
  //     } else {
  //       ul.style.height = `${twoLiHeight}px`;
  //       ul.classList.remove('expanded');
  //     }
  //     arrow.classList.toggle('rotated');
  //   }
    
  //   ul.addEventListener("click", toggleList);
  //   mobileArrow.addEventListener("click", toggleList);
  // });
  // ul contraction function

// systolic function


    document.querySelectorAll('.fold-item-title').forEach(title => {
        title.addEventListener('click', () => {
            const foldItem = title.closest('.fold-item');
            foldItem.classList.toggle('active');
        });
    });

    // === Collapsible item ===
    const collapsibles = document.querySelectorAll('.fold-item-title');
    const header = document.querySelector("header");
    const headerHeight = header.offsetHeight;
    collapsibles.forEach(button => {
      
    const titleHeight = button.offsetHeight;
      
        button.style.scrollMarginTop = `${headerHeight + titleHeight}px`;
      
        button.addEventListener('click', function () {
            const content = this.nextElementSibling;
            const icon = this.querySelector('.toggle-icon');
            const isActive = this.classList.contains('active');

            // Close all other collapsibles with animation
            // collapsibles.forEach(btn => {
            //     if (btn !== this) {
            //         btn.classList.remove('active');
            //         const otherContent = btn.nextElementSibling;
            //         slideUp(otherContent); // Use slideUp for smooth animation
            //         btn.querySelector('.toggle-icon').textContent = '+';
            //     }
            // });

            // Toggle the clicked collapsible with animation
            if (isActive) {
                this.classList.remove('active');
                slideUp(content); // Use slideUp for smooth animation
                icon.textContent = '+';
            } else {
                this.classList.add('active');
                slideDown(content); // Use slideDown for smooth animation
                icon.textContent = '-';
            }
        });
    });

    // === Helper functions for animation ===
    function slideUp(element, duration = 400) {
        element.style.transitionProperty = 'height, margin, padding';
        element.style.transitionDuration = duration + 'ms';
        element.style.boxSizing = 'border-box';
        element.style.height = element.offsetHeight + 'px';
        element.offsetHeight;
        element.style.overflow = 'hidden';
        element.style.height = 0;
        element.style.paddingTop = 0;
        element.style.paddingBottom = 0;
        element.style.marginTop = 0;
        element.style.marginBottom = 0;
        window.setTimeout(() => {
            element.style.display = 'none';
            element.style.removeProperty('height');
            element.style.removeProperty('padding-top');
            element.style.removeProperty('padding-bottom');
            element.style.removeProperty('margin-top');
            element.style.removeProperty('margin-bottom');
            element.style.removeProperty('overflow');
            element.style.removeProperty('transition-duration');
            element.style.removeProperty('transition-property');
        }, duration);
    }

    function slideDown(element, duration = 400) {
        element.style.removeProperty('display');
        let display = window.getComputedStyle(element).display;

        if (display === 'none')
            display = 'block';

        element.style.display = display;
        let height = element.offsetHeight;
        element.style.overflow = 'hidden';
        element.style.height = 0;
        element.style.paddingTop = 0;
        element.style.paddingBottom = 0;
        element.style.marginTop = "0px";
        element.style.marginBottom = 0;
        element.offsetHeight;
        element.style.boxSizing = 'border-box';
        element.style.transitionProperty = "height, margin, padding";
        element.style.transitionDuration = duration + 'ms';
        element.style.height = height + 'px';
        element.style.removeProperty('padding-top');
        element.style.removeProperty('padding-bottom');
        element.style.removeProperty('margin-top');
        element.style.removeProperty('margin-bottom');
        window.setTimeout(() => {
            element.style.removeProperty('height');
            element.style.removeProperty('overflow');
            element.style.removeProperty('transition-duration');
            element.style.removeProperty('transition-property');
        }, duration);
    }

    // === Generate a tag anchor ===
    // const title = document.querySelectorAll('.fold-item-title');
    // const nav = document.getElementById('fold-item-nav');
    // const firstFoldItem = document.querySelector('.fold-item');
    // if (nav && firstFoldItem) {
    //     const navHeight = nav.offsetHeight;
    //     // firstFoldItem.style.marginTop = `${navHeight}px`; 
    // }
    // title.forEach(title => {
    //     const h3 = title.querySelector('h3');
    //     const link = document.createElement('a');
    //     const id = title.getAttribute('id');
    //     console.log("title.id",id)
    //     link.href = `#${id}`;
    //     console.log("link.href",link.href)
    //     link.textContent = h3.textContent;
    //     nav.appendChild(link);
    //     link.addEventListener('click', (e) => {
    //         e.preventDefault();
    //         document.querySelector(link.getAttribute('href')).scrollIntoView({
    //             behavior: 'smooth'
    //         });
    //     });
    // });
